import React, { ReactNode } from "react";

import { PublicFooter } from "@pages/public/PublicFooter";
import { PublicHeader } from "@pages/public/PublicHeader";

import styles from "./PublicPagesWrapper.module.scss";

const PublicPagesWrapper = ({ children, className }: { children?: ReactNode; className?: string }) => {
  return (
    <div className={styles["root-container"]}>
      <div className={styles["header-and-content-wrapper"]}>
        <header>
          <PublicHeader />
        </header>
        <main className={`${className} px-3 px-md-0`}>{children}</main>
      </div>
      <div>
        <div className={styles["footer-content-wrapper"]}>
          <PublicFooter />
        </div>
      </div>
    </div>
  );
};

export default PublicPagesWrapper;
